import { cn } from "@/lib/utils";

const Loader = ({
  variant = "primary",
  containerClassName,
  className
}: {
  variant?: "primary" | "secondary";
  className?: string;
  containerClassName?: string;
}) => {
  if (variant == "primary") {
    return (
      <div className={cn("flex items-center justify-center h-[400px] w-full bg-gray-100", containerClassName)}>
        <div className={cn("w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin", className)}></div>
      </div>
    );
  } else {
    return (
      <div className={cn("flex items-center justify-center h-full bg-transparent", containerClassName)}>
        <div className={cn("w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin", className)}></div>
      </div>
    );
  }
};

export default Loader;
